var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard4B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_beards"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x33_",
    fill: "#85898B",
    d: "M462.2,321.8c5.3-19.3,4.8-39.4,1.6-58.9c-2.6,18.2-5.2,37.4-11.1,55.1 c-2.9,8.6-14.4,14.8-20.6,21.6c-6.4,7.1-10.6,23.1-18.6,28.1c1.1-8.5,0.7-19.7-0.4-26c-0.9-5.3-9.5-7.7-14.1-9.4 c-3.7-1.3-6.6-2-10.4-2.9c-2-0.4-5.9,3-7.9,4.1c-5.8,3.2-11.5,4.5-18.2,5.1c-8.2,0.1-13.5-1.4-19.4-4.5c-1.7-0.9-4.9-3.7-7.2-5.5 c-0.4-0.3-2.4,0.2-2.9,0.3c-3.8,1-6.6,1.7-10.3,3c-4.7,1.6-13.3,4.7-16.7,8.9c-3.9,4.8-2.4,19.5-2.3,25.9 c-6.5-8.5-7.8-19.8-13.1-27.7c-5.3-7.9-19.4-16.9-22.3-25.5c-6-17.7-10.7-31.8-13.4-50.2c-1.4,15.7-3.6,34.8-0.1,50.6 c0.7,3.2,1.5,6.3,2.3,9.4c10.9,36.1,40.3,66.7,70.8,90.8c4.3,2.9,6.3,3.6,11.8,3.5c5.6-0.1,7.7-0.2,13.3,0c2.4,0.1,8.7-0.1,11-0.1 c2.4,0,4.7,0,7.1-0.1c5.5-0.2,7.6-0.3,13.1-0.2c5.5,0.1,9.8-2.1,14.1-4.9c22.4-20.2,43-42.6,56.1-69.3c1.2-2.9,3.8-7.6,4.5-10.8 C459.4,329.9,461.6,324,462.2,321.8z M406.6,360.6c-0.5,4.9-0.7,9.8-3.8,13.9c-2.7,3.7-7.3,6.2-11.2,8.6c-3.6,2.2-9.7,6.1-13,2.2 c-2.3-2.7-4.7-9.1-8.7-9.4c-2.8-0.2-5.7,0.1-8.5,0.2l0,0c-2.2,0.1-4.4,0.4-6.7,0.5c-4,0.3-5.4,6.8-9.3,9.3c-4.4,2.9-13,0.2-17-1.3 c-4.7-1.9-10.4-4.1-13.1-7.7c-3.1-4.2-2.9-11.2-2.6-16.2c0.3-4.4,0.4-6.5,1-10.9c0.7-5.1,5-5.2,14.6-5.7c11.1-0.6,23-1.8,34.1-2 c10.9,0.1,21.7-0.2,32.7,0.1c4.5,0.1,9.9-0.4,10.6,4.8C406.2,351.3,407,356.1,406.6,360.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard4B);
export default __webpack_public_path__ + "static/media/man_beard_4b.c3e569f78935ca4ee9b4f6dc44f7226a.svg";
export { ForwardRef as ReactComponent };